import * as React from "react";
import { Conductor } from "@models/conductor";
import { Modal, Table } from "antd";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import { PaginationDefaultParams } from "@components/custom/Paginator";
import {getFormattedPrice} from "@utils";
import FormattedDateTime from "@components/custom/FormattedDateTime";


type Props = {
  data: Conductor[];
  loading: boolean;
  deleteFn: (item: Conductor) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const SuppliersPaymentsTable: React.FC<Props> = props => {
  const { data, loading, currentPage, footer } = props;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;

  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`} />,
      width: 30,
      dataIndex: "index",
      key: "id",
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: <FormattedMessage id="app.video_contents" defaultMessage={`Video Content`} />,
      width: 70,
      align:"right",
      dataIndex: "video_content_title",
      key: "video_content_title",
    },
    {
      title: <FormattedMessage id="app.stat_type" defaultMessage={`Stat Type`} />,
      width: 30,
      dataIndex: "stat_type",
      key: "stat_type",
      render: (stat_type, recors) => <span><FormattedMessage id={`app.${stat_type}`}/></span>
    },
    {
      title: <FormattedMessage id="app.package_amount" defaultMessage={`Package Amount`} />,
      width: 30,
      dataIndex: "package_amount",
      key: "package_amount",
      render: (package_amount, recors) => (
       <span>
         {getFormattedPrice(package_amount)}
       </span>
      )
    },
    {
      title: <FormattedMessage id="app.supplier_share_amount" defaultMessage={`Supplier Share Amount`} />,
      width: 30,
      dataIndex: "supplier_share_amount",
      key: "supplier_share_amount",
      render: (supplier_share_amount, recors) => (
        <span>
         {getFormattedPrice(supplier_share_amount)}
       </span>
      )
    },
    {
      title: <FormattedMessage id="app.start_date" defaultMessage={`Start Date`}/>,
      width: 120,
      dataIndex: 'stat_date_time',
      key: 'stat_date_time',
      render: (text, record) => <FormattedDateTime date={text}/>
    },
  ];

  return (
    <Table
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
      footer={footer}
    />
  );
};

export default injectIntl(SuppliersPaymentsTable);
